import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TooltipPrimary from "../../components/tooltips/TooltipPrimary";
import MenuIcon from "@mui/icons-material/Menu";
import ButtonIcon from "../../components/button/ButtonIcon";
import {
  setfeedbackPopup,
  setsidebarActive,
} from "../../redux/features/stylesSlice";

import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { sidebarIcons } from "../data/sidebarData";

const Sidebar = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const { sidebarActive } = useSelector((state) => state.styles);

  const { sidebarData } = useSelector((state) => state.data);

  return (
    <div className={`sidebar ${sidebarActive ? "sidebar-active" : ""}`}>
      <ButtonIcon onClick={() => dispatch(setsidebarActive(true))}>
        <MenuIcon />
      </ButtonIcon>
      <div className="menu">
        <div className="section">
          {sidebarData.map((item) => (
            <TooltipPrimary
              key={item.categoryName_chr}
              text={item.categoryName_chr}
            >
              <div
                onClick={() => {
                  const el = document.getElementById(item.categoryName_chr);
                  el.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  });
                }}
                className={`tab ${false ? "tab-active" : ""}`}
              >
                <div className="icon">
                  {sidebarIcons[item.categoryName_chr]}
                </div>
              </div>
            </TooltipPrimary>
          ))}
        </div>
      </div>

      <div className="feedback-tab">
        <TooltipPrimary text="Feedback">
          <div
            className={`tab ${pathname === "/settings" ? "tab-active" : ""}`}
            onClick={() => dispatch(setfeedbackPopup(true))}
          >
            <div className="icon">
              <ChatBubbleOutlineIcon />
            </div>
          </div>
        </TooltipPrimary>
      </div>
    </div>
  );
};

export default Sidebar;
